import { create } from 'zustand'

// Cross-component asks for a habit's session plan: a row chip opening the sheet
// straight into the plan's "choose" step, and the fullscreen session view
// (shown over the sheet, which stays open beneath it).
type State = {
  chooseFor: string | null
  fullscreen: string | null
  requestChoose: (habitId: string) => void
  clearChoose: () => void
  setFullscreen: (habitId: string | null) => void
}

export const useSessionPlanUi = create<State>((set) => ({
  chooseFor: null,
  fullscreen: null,
  requestChoose: (habitId) => set({ chooseFor: habitId }),
  clearChoose: () => set({ chooseFor: null }),
  setFullscreen: (habitId) => set({ fullscreen: habitId }),
}))
